import { InlineEditButton } from "@/components/ui/buttons/InlineEditButton";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";

interface GoalInfoItemProps {
  value: string;
  onChange: () => void;
}

export const GoalInfoItem = ({ value, onChange }: GoalInfoItemProps) => {
  return (
    <div className="flex h-[46px] items-center justify-between rounded-[24px] bg-[#f7f2ff] pr-1 pl-3">
      <span className={cn(textVariants.inputText, "leading-[14px] font-bold")}>{value}</span>
      <InlineEditButton onClick={onChange} />
    </div>
  );
};
